module.exports = __webpack_public_path__ + "55a4f569a996ae17e2b5da7506514a00.png";